<form class="popupForm" style="min-height: 300px;">
  <div class="common" mat-dialog fxLayout="column" fxLayoutAlign="space-between" style="min-height: inherit;">
    <div mat-dialog-title class="flex-row-center flex-justify-space-between">
      <ng-container *ngIf="mode != 'edit_game'">{{'event_view'  | GetLabelPipe}}</ng-container>
      <ng-container *ngIf="mode == 'edit_game'">{{'game_result' | GetLabelPipe}}</ng-container>
      <div class="flex-row-center"
           [class.flex-justify-end]="true"
           style="width: 75px;">

        <button mat-icon-button *ngIf="allowEventEdit"
                (click)="editClick()" alt="settings" title="settings">
          <mat-icon>edit</mat-icon>
        </button>
        <button mat-icon-button *ngIf="allowEventComment"
                (click)="commentClick()" alt="edit comment" title="edit comment">
          <mat-icon>comment</mat-icon>
        </button>
        <button mat-icon-button mat-dialog-close alt="close" title="close">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>
    <mat-dialog-content class="when-fx-layout-broke" style="display: flex !important; min-height: 250px;">
      <div class="event-view-content">
        <div *ngIf="state === 'default'" (click)="clickUser(profileLeft)" style="width: 100%;">
          <div class="flex-row-center flex-justify-space-around is-relative">
            <div class="event-date" style="position: absolute;">
              {{listItem.cdate | fsDate: false:!allowFullView}}
            </div>
            <div matRipple class="profile-left-button flex-column-center column-button"
                 [class.faded]="true">
              <mat-icon>comment</mat-icon>
              <div>{{'kontakt' | GetLabelPipe}}</div>
            </div>
            <div class="event-user-icon flex-row-center bigger-badge-popup"
                 matBadgeColor="accent" matBadge="{{profileLeft.rank}}">
              <img src="{{profileLeft['picture_src_preview']}}"
                   alt="{{profileLeft['shipping_name']}}" title="{{profileLeft['shipping_name']}}"
                   style="{{ profileLeft['sex']==='F' ? 'border-color: #FF1744' : 'border-color: #448AFF' }}"
              />
            </div>
            <div matRipple class="profile-right-button flex-column-center column-button"
                 [class.faded]="profileLeft['id'] == application.user.id">
              <mat-icon>account_box</mat-icon>
              <div>{{'account' | GetLabelPipe}}</div>
            </div>
          </div>
          <div class="user-name user-name-as-link">
            {{profileLeft['shipping_name']}}
          </div>
        </div>

        <ng-container *ngIf="state === 'split'">
          <div class="split-items-container">
            <div class="profile-left flex-column-center" (click)="clickUser(profileLeft, 'left')">
              <div class="event-user-icon event-user-icon-split bigger-badge-split-popup"
                   matBadge="{{profileLeft['cup_position'] ? profileLeft['cup_position'] : profileLeft['rank']}}" matBadgeColor="accent">
                <img src="{{profileLeft['picture_src_preview']}}"
                     alt="{{profileLeft['shipping_name']}}" title="{{profileLeft['shipping_name']}}"
                     style="{{ profileLeft['sex']==='F' ? 'border-color: #FF1744' : 'border-color: #448AFF' }}"
                />
                <div *ngIf="mode == 'edit_game'" class="edit-game-profile-icon flex-row-center flex-justify-center">
                  <mat-icon>edit</mat-icon>
                </div>
              </div>
              <div class="user-name user-name-split user-name-as-link">
                {{profileLeft['shipping_name']}}
              </div>
              <div class="flex-row-center points-label" [class.red-points-label]="(profileLeft['rank_add'] < 0)"
                   *ngIf="this.eventPayload['status']==='confirmed' && profileLeft['rank_add']">
                <mat-icon>emoji_events</mat-icon><span>&nbsp;{{(profileLeft['rank_add'] > 0) ? '+'+profileLeft['rank_add'] : profileLeft['rank_add']}}</span>
              </div>
              <div class="flex-row-center points-label" *ngIf="this.eventPayload['status']==='confirmed' && profileLeft['points_add']">
                <mat-icon>savings</mat-icon><span>&nbsp;+{{profileLeft['points_add']}}</span>
              </div>
            </div>
            <div class="event-score flex-column-center">
              <div *ngIf="eventPayload['status']==='confirmed'">{{eventPayload['score']}}</div>
              <div *ngIf="eventPayload['status']==='canceled' || eventPayload['type']==='trainer_booking_cancel'">❌</div>
              <div *ngIf="!eventPayload['trainer_id'] && ['proposal','pending','score_confirmation'].includes(eventPayload['status'])">⏳</div>
            </div>
            <div class="profile-right flex-column-center" (click)="clickUser(profileRight, 'right')">
              <div class="event-user-icon event-user-icon-split bigger-badge-split-popup"
                   matBadge="{{profileRight['cup_position'] ? profileRight['cup_position'] : profileRight['rank']}}" matBadgeColor="accent">
                <img src="{{profileRight['picture_src_preview']}}"
                     alt="{{profileRight['shipping_name']}}" title="{{profileRight['shipping_name']}}"
                     style="{{ profileRight['sex']==='F' ? 'border-color: #FF1744' : 'border-color: #448AFF' }}"
                />
                <div *ngIf="mode == 'edit_game'" class="edit-game-profile-icon flex-row-center flex-justify-center">
                  <mat-icon>edit</mat-icon>
                </div>
              </div>
              <div class="user-name user-name-split user-name-as-link">
                {{profileRight['shipping_name']}}
              </div>
              <div class="flex-row-center points-label" [class.red-points-label]="(profileRight['rank_add'] < 0)"
                   *ngIf="this.eventPayload['status']==='confirmed' && profileRight['rank_add']">
                <mat-icon>emoji_events</mat-icon><span>&nbsp;{{(profileRight['rank_add'] > 0) ? '+'+profileRight['rank_add'] : profileRight['rank_add']}}</span>
              </div>
              <div class="flex-row-center points-label" *ngIf="this.eventPayload['status']==='confirmed' && profileRight['points_add']">
                <mat-icon>savings</mat-icon><span>&nbsp;+{{profileRight['points_add']}}</span>
              </div>
            </div>
          </div>

          <form [formGroup]="componentForm"
                *ngIf="state === 'split' && mode === 'edit_game'" class="event-description flex-row-center flex-justify-center">
            <mat-form-field appearance="outline" color="accent" style="width: 20%">
              <mat-label>Score</mat-label>
              <select matNativeControl formControlName="scoreLeft">
                <option *ngFor="let i of [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15];"
                        value="{{i}}">{{i}}</option>
              </select>
            </mat-form-field>
            <div style="width: 80px; text-align: center">:</div>
            <mat-form-field appearance="outline" color="accent" style="width: 20%">
              <mat-label>Score</mat-label>
              <select matNativeControl  formControlName="scoreRight">
                <option *ngFor="let i of [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15];"
                value="{{i}}">{{i}}</option>
              </select>
            </mat-form-field>
          </form>
          <div *ngIf="state === 'split' && mode !== 'edit_game'" class="event-description flex-column-center">
            <ng-container *ngIf="['game_proposal','tournament_game_proposal'].includes(this.eventPayload['type'])">
              <div class="event-description-title">{{'game_status_'+eventPayload['status'] | GetLabelPipe}}</div>
            </ng-container>
            <ng-container *ngIf="['trainer_booking_add'].includes(this.eventPayload['type'])">
<!--              <div class="event-description-title">{{'trainer_booking_add_label' | GetLabelPipe}}</div>-->
<!--              <div class="event-description-title">{{application.account.payload_parsed['labels']['training']}}</div>-->
              <div class="event-description-title">{{'training' | GetLabelPipe}}</div>
            </ng-container>
            <ng-container *ngIf="['trainer_booking_cancel'].includes(this.eventPayload['type'])">
<!--              <div class="event-description-title">{{'trainer_booking_cancel_label' | GetLabelPipe}}</div>-->
<!--              <div class="event-description-title">{{application.account.payload_parsed['labels']['canceled_training']}}</div>-->
              <div class="event-description-title">{{'canceled_training' | GetLabelPipe}}</div>
            </ng-container>
            <div *ngIf="eventPayload['class_name'] && eventPayload['class_id']"
                 class="event-description-line">
              {{'event_group' | GetLabelPipe}}: <a target="_blank" href="/{{application.appLang}}/squash/classview/{{eventPayload['class_id']}}">{{eventPayload['class_name']}}</a>
            </div>
            <div *ngIf="this.eventPayload['pickedTime']"
                 class="event-description-line">
              {{'date_and_time' | GetLabelPipe}}: {{(eventPayload['pickedTime']*1000) | fsDate: false:!allowFullView}}
            </div>
            <div *ngIf="eventPayload['event_duration'] && allowFullView"
                 class="event-description-line">
              {{'duration' | GetLabelPipe}}: {{eventPayload['event_duration']/60}}{{'mins'|GetLabelPipe}}
            </div>
            <div *ngIf="eventPayload['comment'] && allowFullView"
                 class="event-description-line">
              {{'comment' | GetLabelPipe}}: {{eventPayload['comment']}}
            </div>
          </div>
        </ng-container>

        <div *ngIf="state !== 'split'" class="event-description flex-column-center">

          <div class="event-description-title"
               *ngIf="eventPayload['type'] === 'play_config_update'">
            {{'play_config_update_label' | GetLabelPipe}}</div>
          <div class="event-description-title"
               *ngIf="eventPayload['type'] === 'tcs_confirmation'">
            {{'tcs_confirmation_label' | GetLabelPipe}}</div>
          <div class="event-description-title"
               *ngIf="eventPayload['type'] === 'class_add'">
            {{'class_add_label' | GetLabelPipe}}</div>
          <div class="event-description-title"
               *ngIf="eventPayload['type'] === 'class_join'">
            {{'class_join_label' | GetLabelPipe}}</div>
          <div class="event-description-title"
               *ngIf="eventPayload['type'] === 'help_request'">
            {{'help_request_label' | GetLabelPipe}}</div>
          <div class="event-description-title"
               *ngIf="eventPayload['type'] === 'help_response'">
            {{'help_response_label' | GetLabelPipe}}</div>
          <div class="event-description-title"
               *ngIf="['play_config_update','help_request','help_response','tcs_confirmation','class_add','class_join'].indexOf(eventPayload['type']) === -1">
            {{listItem.name}}</div>

          <div *ngIf="eventPayload['message']" class="event-description-line">
            {{eventPayload['message']}}
          </div>

          <div *ngIf="eventPayload['type'] === 'play_config_update'" class="event-description-line">
            <ng-container *ngIf="!eventPayload.play_conf?.weekdays && !eventPayload.play_conf?.weekends">
              {{'play_conf_not_set' | GetLabelPipe}}<br/>
            </ng-container>
            <ng-container *ngIf="eventPayload.play_conf?.weekdays">
              {{'weekdays_range'|GetLabelPipe}}: {{eventPayload.play_conf.weekdays | PlayConfigLabelPipe}}<br/>
            </ng-container>
            <ng-container *ngIf="eventPayload.play_conf?.weekends">
              {{'weekends_range'|GetLabelPipe}}: {{eventPayload.play_conf.weekends | PlayConfigLabelPipe}}<br/>
            </ng-container>
          </div>

          <div *ngIf="eventPayload['class_name'] && eventPayload['class_id']"
               class="event-description-line">
            {{'event_group' | GetLabelPipe}}: <a target="_blank" href="/{{application.appLang}}/squash/classview/{{eventPayload['class_id']}}">{{eventPayload['class_name']}}</a>
          </div>
          <div *ngIf="eventPayload['event_timestamp']"
               class="event-description-line">
            {{'date_and_time' | GetLabelPipe}}: <span>{{(eventPayload['event_timestamp']*1000) | fsDate: false:!allowFullView}}</span>
          </div>
          <div *ngIf="parentEventPayload?.event_timestamp"
               class="event-description-line">
            {{'date_and_time' | GetLabelPipe}}: <span>{{(parentEventPayload['event_timestamp']*1000) | fsDate: false:!allowFullView }}</span>
          </div>
        </div>
      </div>
    </mat-dialog-content>
    <div class="is-relative" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px">
      <button mat-button class="cancel widerButton font16" (click)="onNoClick()">
        {{'close' | GetLabelPipe}}
      </button>
      <button *ngIf="mode == 'edit_game'" color="accent"
              [disabled]="!profileLeft['id'] || !profileRight['id']"
              mat-raised-button class="cancel widerButton font16" (click)="saveGame()">
        {{'save' | GetLabelPipe}}
      </button>
<!--      <button *ngIf="allowEventDelete && (eventPayload['type'] == 'game_proposal' && eventPayload['status'] != 'canceled')" color="warn"-->
<!--              [disabled]="mode == 'loading'"-->
<!--              mat-raised-button class="cancel widerButton font16" (click)="deleteItem(true)">-->
<!--        {{'cancel' | GetLabelPipe}}-->
<!--      </button>-->

      <button *ngIf="allowEventCancel" color="warn"
              [disabled]="mode == 'loading'"
              mat-raised-button class="cancel widerButton font16" (click)="cancelItem()">
        {{'cancel2' | GetLabelPipe}}
      </button>
      <button *ngIf="allowEventDelete" color="warn"
              [disabled]="mode == 'loading'"
              mat-raised-button class="cancel widerButton font16" (click)="deleteItem()">
        <ng-container *ngIf="(eventPayload['type'] != 'game_proposal' || eventPayload['status'] == 'canceled')">
          {{'delete' | GetLabelPipe}}
        </ng-container>
        <ng-container *ngIf="eventPayload['type'] == 'game_proposal' && eventPayload['status'] != 'canceled'">
          {{'cancel' | GetLabelPipe}}
        </ng-container>
      </button>

<!--      <button *ngIf="['booking_add','trainer_booking_add'].includes(eventPayload['type'])"-->
<!--        mat-raised-button class="cancel widerButton font16" (click)="onNoClick()" color="accent">-->
<!--        <mat-icon>edit</mat-icon>-->
<!--        {{'edit' | GetLabelPipe}}-->
<!--      </button>-->
    </div>
  </div>
</form>
